var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 290,
    viewBox: "0 0 360 290",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M153.212 44.96C89.5482 0.619673 41.2248 -4.01659 -1 2.24241V290H362V84.3917C245.439 89.2738 223.309 93.7803 153.212 44.96Z",
    fill: "#F9F4E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M310.48 195.728L310.48 167.216L356.383 176.5L310.48 195.728Z",
    fill: "#66C67F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-15.8704 328.829L-17.2197 284.302L-14.5211 249.22L76.3314 227.632L-15.8704 328.829Z",
    fill: "#F1805E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M236 237L191 289.5H375.5L370.5 237H236Z",
    fill: "#FFD150"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileFooter);
export default __webpack_public_path__ + "static/media/mobile_footer.084b4342f71fce2a48bcd839ca7ff9a1.svg";
export { ForwardRef as ReactComponent };